var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0a.62.62,0,0,0-.23,0L1.16,5.11a.68.68,0,0,0-.46.74L3,24.72a.68.68,0,0,0,.36.52l12.28,6.68A.73.73,0,0,0,16,32a.66.66,0,0,0,.33-.09l12.34-6.76a.7.7,0,0,0,.36-.53L31.3,5.76A.71.71,0,0,0,30.83,5L16.18,0A.62.62,0,0,0,16,0ZM16,3.48,25,23H22L20,18.79H12L10,23H7Zm0,6.61L13.27,16h5.46Z",
    fill: "#60f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.c8daf54a5f514b3e0c2dc47946b7b13c.svg";
export { ForwardRef as ReactComponent };